import React from 'react';
import { Md3DRotation } from "react-icons/md";
import Helper from '../../utils/helper';
import { isMobile } from 'react-device-detect';

export default class IndividualProject extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            show3d: false
        };
        this.isShow3dOnDemand = Helper.isShow3dOnDemand();
    }

    on3dClick = () => {
        this.setState({
            show3d: true
        });
    }

    getTypeNameByKey = (key) => {
        if (key == "balcon") {
            return this.props.t('homeProject.balcons');
        } else if (key == "canopy") {
            return this.props.t('homeProject.canopies');
        } else if (key == "gate") {
            return this.props.t('homeProject.gate');
        } else {
            return this.props.t('homeProject.stairs');
        }
    }

    onSelfClick = () => {
        if (this.isShow3dOnDemand && !this.state.show3d) {
            this.setState({
                show3d: true
            });
        } else {
            this.props.onClick();
        }
    }

    render() {
        const { t, project } = this.props;
        const editorSrc = Helper.editorPreviewLink(project.id);
        return (
            <div className={!isMobile ? "projItem" : "projItem-m"} onClick = { this.onSelfClick } >
                <div className={!isMobile ? "projItem3d" : "projItem3d-m"}>
                    <img style={{ width: '100%' }}
                        src={project.firstSpecificationImage} />
                    {/*(this.isShow3dOnDemand && !this.state.show3d) ?
                        <>
                            <img style={{ width: '100%' }}
                                src={project.firstSpecificationImage} />
                            <Md3DRotation className={!isMobile ? "h-icon-3d" : "h-icon-3d-mobile"} onClick={this.on3dClick} />
                        </>
                        :
                        <iframe
                            width="100%"
                            height="100%"
                            src={editorSrc}
                            frameBorder="0"
                        />
                    */}
                </div>
                <div className="align-center" style={{ fontSize: "16px" }}><b>{this.getTypeNameByKey(project.typeKey)}</b></div>
            </div>
        );
    }
}